import { LocalStorageService } from "./LocalStorageService"

/** Authentication namespace
 * @namespace
 */
export const Auth = {
  isLoggedIn: false,
  token: null,
  userName: null,
  refreshToken: null,
  mainPartnerId: null,
  expirationTime: null,
  /** Check is user authenticated or not */
  isAuthenticated: function () {
    const authData = LocalStorageService.get('authorizationData');

    if (authData && authData.access_token) {
      this.isLoggedIn = true;
      this.token = authData.access_token;
      this.userName = authData.username;
      this.refreshToken = authData.refresh_token;
      return true;
    } else {
      return false;
    }
  },

  /** 
    * @typedef AuthData
    * @property {boolean} isLoggedIn Is user loged in or not
    * @property {string} token Token
    * @property {string} userName Username
    * @property {string} refreshToken Refresh token
    */

  /** Get authenticated user's data
   * @returns {AuthData}*/

  fillAndGetData: function () {
    const authData = LocalStorageService.get("authorizationData");

    if (authData) {
      this.isLoggedIn = true;
      this.token = authData.access_token;
      this.userName = authData.UserName;
      this.refreshToken = authData.refresh_token;
      this.mainPartnerId = authData.MainPartnerId;
      this.expirationTime = authData['.expires'];
    }
    return this;
  },

  /** Invalidate user session*/
  invalidateSession: function () {
    LocalStorageService.clear();

    this.isLoggedIn = false;
    this.token = null;
    this.userName = null;
    this.refreshToken = null;
    this.mainPartnerId = null;
  },

  isExpired: function () {
      const expirationTime = new Date(this.expirationTime);
      const now = new Date();
      return expirationTime < now;
  }
};


// WEBPACK FOOTER //
// ./src/services/Auth.js